export const partnerLogType = {
    NEW_USER: 0,
    OLD_USER: 1,
    GAME_USER: 2,
    DO_QUEST: 3,
    VERIFIED_QUEST: 4,
    CLAIM_QUEST: 5,
}